export default "__VITE_ASSET__C88d3J9n__"